import React, { Component } from "react";
import Layout from "../components/Layout";
import Banner from "../components/Banner";
import MenuManizales from "../components/MenuManizales";
import Sponsors from "../components/Sponsors";
import GalleryComponent from "../components/GalleryComponent";

class GalleryManizales extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      isLoaded: false,
      data: {},
    };
  }

  componentDidMount() {
    fetch("https://legendofeldorado.com/series-admin-temporal/api/gallery_race/manizales-2024")
      .then((res) => res.json())
      .then(
        (res) => {
          this.setState({
            isLoaded: true,
            data: res,
          });
        },

        (error) => {
          this.setState({
            isLoaded: true,
            error,
          });
        }
      );
  }

  render() {
    const { photos, sponsors } = this.state.data;

    return (
      <Layout>
        <Banner id={15} city="manizales" thumb="/manizales/logo_manizales.png" />
        <MenuManizales />
        <div className="row content-manizales">
          <div className="container" id="contenido_video">
            <div className="row">
              <div className="col-12">{photos && <GalleryComponent city="manizales" images={photos} />}</div>
            </div>
          </div>
        </div>
        {sponsors && <Sponsors customClass="--manizales" items={sponsors} />}
      </Layout>
    );
  }
}

export default GalleryManizales;
